import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../auth/AuthContext";
import API_BASE_URL from "../../config/api";

export default function PasswordSetupPrompt() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [hidden, setHidden] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (hidden || user?.password_setup_status !== "pending") return null;

  const skip = async () => {
    setSaving(true);
    setError("");
    const response = await fetch(`${API_BASE_URL}/api/auth/password-setup`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status: "skipped" }),
    });
    setSaving(false);
    if (!response.ok) return setError("Unable to save your choice. Please try again.");
    setUser((current) => ({ ...current, password_setup_status: "skipped" }));
  };

  const addPassword = () => {
    setHidden(true);
    navigate("/account?tab=security&action=password");
  };

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm" role="dialog" aria-modal="true" aria-labelledby="password-setup-title">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl dark:bg-gray-900">
        <h2 id="password-setup-title" className="text-xl font-semibold text-gray-900 dark:text-white">Add a password?</h2>
        <p className="mt-2 text-sm leading-6 text-gray-600 dark:text-gray-300">
          You signed in securely with a one-time code. A password is optional and gives you another way to sign in.
        </p>
        {error && <p role="alert" className="mt-3 text-sm text-red-600">{error}</p>}
        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button type="button" disabled={saving} onClick={skip} className="rounded-xl border border-gray-300 px-4 py-2.5 font-medium text-gray-700 disabled:opacity-50 dark:border-gray-700 dark:text-gray-200">
            {saving ? "Saving…" : "Not now"}
          </button>
          <button type="button" disabled={saving} onClick={addPassword} className="rounded-xl bg-blue-600 px-4 py-2.5 font-semibold text-white disabled:opacity-50">
            Add password
          </button>
        </div>
      </div>
    </div>
  );
}
